import {

    voucherPinList,
    voucherTemplate,
    voucherPrices,
    voucherVoucherPinList,
    voucherVoucherPinListWithStatus,
    updateVoucher,
    deleteVoucher,
    downloadVoucher,
    saveVoucherPin,
    processVoucher,
} from "@/http/setup/vouchers"

export default {
    namespaced: true,
    state: {

        voucherList: [],
        voucherFormTemplate: {},
        voucherProducts: [],
        createVoucher: null,
        voucherPinList: [],
    },
    actions: {

        async setVoucherList({ commit }) {
            const resp = await voucherPinList();
            commit('SET_VOUCHER_LIST', resp.data.pageItems);
            return resp;
        },
        async setVoucherFormTemplate({ commit }) {
            const resp = await voucherTemplate();
            commit('SET_VOUCHER_FORM_TEMPLATE', resp.data);
            return resp;
        },
        async setVoucherProduct({ commit }) {
            const resp = await voucherPrices();
            commit('SET_VOUCHER_PRODUCT', resp.data);
            return resp;
        },
        async setPostvoucher({ commit, state }, data) {
            try {
                if (state.formError != null) {
                    commit('FORM_ERROR', null);
                }
                if (state.createVoucher != null) commit('SET_POST_VOUCHER', null);
                const resp = await saveVoucherPin(data);
                if (resp.data.resourceId) {
                    commit('SET_POST_VOUCHER', resp.data.resourceId);
                    return resp;
                }
            } catch (e) {
                if (state.formError != null) {
                    commit('FORM_ERROR', null);
                }
                commit('FORM_ERROR', e.message.errors[0].defaultUserMessage);

                return e.message;
            }
        },
        async processVoucherAc(_, data) {
            return await processVoucher(data.voucherId, data);
        },
        async setVoucherPinList({ commit }, id) {
            const resp = await voucherVoucherPinList(id);
            commit('SET_VOUCHER_PIN_LIST', resp.data.pageItems);
            return resp;
        },
        async setVoucherPinListWithStatus({ commit }, data) {
            const resp = await voucherVoucherPinListWithStatus(data.id, data.status);
            commit('SET_VOUCHER_PIN_LIST', resp.data.pageItems);
            return resp;
        },
        async updateVoucherPins(_, data) {
            const resp = await updateVoucher(data.id, data.data);
            return resp;
        },
        async deleteVoucherPins(_, data) {
            const resp = await deleteVoucher(data.id, data.data);
            return resp;
        },
        async downloadVoucherAc(_, id) {
            return await downloadVoucher(id);
        },

    },
    mutations: {

        ['SET_VOUCHER_LIST'](state, payload) {
            Object.assign(state, { voucherList: payload });
        },
        ['SET_VOUCHER_FORM_TEMPLATE'](state, payload) {
            Object.assign(state, { voucherFormTemplate: payload });
        },
        ['SET_VOUCHER_PRODUCT'](state, payload) {
            Object.assign(state, { voucherProducts: payload });
        },
        ['SET_POST_VOUCHER'](state, payload) {
            Object.assign(state, { createVoucher: payload });
        },
        ['SET_VOUCHER_PIN_LIST'](state, payload) {
            Object.assign(state, { voucherPinList: payload });
        },
        ['CREATE_TEAM_RESP'](state, payload) {
            Object.assign(state, { createTeamResp: payload });
        },
        ['SET_CREATE_TEAM_TEMPLATE'](state, payload) {
            Object.assign(state, { teamTemplate: payload });
        },
        ['SET_TEAM_LIST_DATA'](state, payload) {
            Object.assign(state, { teamList: payload });
        },
        ['SET_TEAMUSER_LIST_DATA'](state, payload) {
            Object.assign(state, { teamUserList: payload });
        },
        ['SET_TEAMUSER_TEMPLATE'](state, payload) {
            Object.assign(state, { teamuserTemplate: payload });
        },
        ['CREATE_TEAMUSER_RESP'](state, payload) {
            Object.assign(state, { createTeamUserResp: payload });
        },
        ['SET_TEAM_BY_ID'](state, payload) {
            Object.assign(state, { teamById: payload });
        },
        ['SET_TICKET_USER_BY_ID'](state, payload) {
            Object.assign(state, { teamUserById: payload });
        },
        ['SET_PUT_PRICE_REGION'](state, payload) {
            Object.assign(state, { updatepriceRegion: payload });
        },

    }
}